import React from "react";
import yeartc from '../img/yeartc.png'

class Fixed extends React.Component {
    render() {
        // 移除悬浮窗
        return null;
        // return (
        //     <div className='text-center _fixed position-absolute'>
        //             <div>
        //                 <div>咨询电话</div>
        //                 <div>400-1022771</div>
        //             </div>
        //                 <img src={yeartc}  className="d-block w-100"/>
        //         </div>
        // );
    }
}

export default Fixed;
